import React, { useEffect, useState } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import axios from "axios";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import { Form } from "react-bootstrap";
import swal from "sweetalert";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory, useParams } from "react-router-dom";
import { Player } from "video-react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";
import { useRef } from "react";
// import DateTime from "react-datetime-picker/dist/DateTimePicker";
// import DatePicker from "react-datetime"
// import "react-datetime/css/react-datetime.css";
// import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";
// import { DateTimePicker } from "@syncfusion/ej2-calendars";

export default function EditAdLession() {
  const { token } = isAutheticated();
  const { adlessionId } = useParams();
  const [success, setSuccess] = useState(false);
  const [lession, setLession] = useState({
    madeBy: null,
    title: "",
    description: "",
    subject: "",
    languageid: "",
    live: false,
    thumbnail: "",
    banner: "",
    launchDate: new Date(),
    video: "",
    directors: "",
    Writers: "",
    Actors_list: [],
    Plot: "",
  });

  const tab1 = useRef();
  const tab2 = useRef();
  const tab3 = useRef();

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [formData, setFormData] = useState(new FormData());
  const [validForm, setvalidForm] = useState(false);
  const [error, setError] = useState("");
  const [metaDataTitle, setmetaDataTitle] = useState("");
  const [metaDataPlot, setmetaDataPlot] = useState("");
  const [metaDataDirector, setmetaDataDirector] = useState("");
  const [metaDataWriter, setmetaDataWriter] = useState("");
  const [metaDataCrew, setmetaDataCrew] = useState([]);
  const [metaformData, setMetaformData] = useState({});
  const [searchMovie, setSearchMovie] = useState("");
  const [movieList, setMovieList] = useState([]);
  const [fill, setFill] = useState(false);
  const [dataLoad, setdataLoad] = useState(true);



  const wordLimit = {
    title: 50,
    description: 600,
  };

  const [titleLen, setTitleLen] = useState(wordLimit.title);
  const [descriptionLen, setDescriptionLen] = useState(wordLimit.description);

  const fillMetadata = (id) => {
    setMovieList([]);
    axios
      .post(
        `${API}/api/adlesson/search_metadata_id/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        // console.log("here meta data", response)
        const data = response.data;
        setmetaDataTitle(data.title);
        setmetaDataPlot(data.plot);
        setmetaDataDirector(data.directors);
        setmetaDataWriter(data.writers);
        setmetaDataCrew(data.actorList);
        setFill(true);
        //   setMetaformData({...metaformData,"Id":data.id,"directors":data.directors,"type":data.type,"year":data.year,"image":data.image
        //   ,"genres":data.genres,"Languages":data.languages,"RuntimeStr":data.runtimeStr,"Plot":data.plot
        //   ,"Actors_list":data.actorList,"Writers":data.writers,"Ratings":data.ratings
        //  })
        formData.set("Id", data.id);
        formData.set("directors", data.directors);
        formData.set("type", data.type);
        formData.set("year", data.year);
        formData.set("genres", data.genres);
        formData.set("Languages", data.languages);
        formData.set("RuntimeStr", data.runtimeStr);
        formData.set("Plot", data.plot);
        if (data.actorList) {
          formData.set("Actors_list", data.actorList);
        } else {
          formData.set("Actors_list", []);
        }

        formData.set("Writers", data.writers);
        formData.set("Ratings", data.ratings);
        //data.actorList
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSearchMovie = (searchText) => {
    //e.preventDefault();
    //await setSearchMovie(e.target.value);
    console.log("namesearch", searchText);
    console.log("token", token);
    axios
      .post(
        `${API}/api/adlesson/search_metadata/${searchText}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        const userdata = response.data;

        //console.log(response.data);
        //console.log(userdata);
        setMovieList(userdata.results);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // useEffect(() => {
  //   // $("#summernote").summernote();
  //   console.log(lession.launchDate);

  //   axios
  //     .get(`${API}/api/languages`)
  //     .then((response) => {
  //       // console.log(response);
  //       setLanguages(response.data.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    const fetchLessonDetails = () => {
      setdataLoad(true); // Start loading

      axios
        .get(`${API}/api/adlesson/${adlessionId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const data = response.data?.data;

          console.log("Fetched lesson details:", data);

          setLession({
            ...data,
            // Uncomment and adjust the following lines if needed
            // subject: data.subject?._id,
            // languageid: data.languageid,
            // launchDate: new Date("yyyy-MM-dd hh:mm").formate(
            //   new Date("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'").parse(data.launchDate)
            // ),
          });

          setTitleLen(wordLimit.title - (data?.title?.length || 0)); // Calculate remaining title length
          setDescriptionLen(wordLimit.description - (data?.description?.length || 0)); // Calculate remaining description length
        })
        .catch((err) => {
          console.error("Error fetching lesson details:", err);
        })
        .finally(() => {
          setdataLoad(false); // Ensure loading stops after completion
        });
    };

    fetchLessonDetails(); // Call the function to fetch data
  }, [, token, adlessionId]); // Ensure dependencies are correctly included

  useEffect(() => {
    formData.set("title", lession.title);
    formData.set("description", lession.description);
  }, [lession]);

  const handleChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    formData.delete(name);
    //console.log(value,name);

    if (name == "video") {
      const maxAllowedSize = 100 * 1024 * 1024;
      if (e.target.files[0]?.type !== "video/mp4") {
        e.target.value = "";
        swal({
          title: "Video should be of mp4 only",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      if (e.target.files[0].size > maxAllowedSize) {
        e.target.value = "";
        swal({
          title: "Your video file size must be less than 100mb",
          icon: "error",
          button: "Close",
          dangerMode: true,
        });
        return;
      }
      setLession({ ...lession, video: URL.createObjectURL(e.target.files[0]) });
      formData.set("video", e.target.files[0]);
    } else if (name == "thumbnail") {
      if (
        e.target.files[0]?.type === "image/jpeg" ||
        e.target.files[0]?.type === "image/png" ||
        e.target.files[0]?.type === "image/jpg"
      ) {
        setLession({
          ...lession,
          thumbnail: URL.createObjectURL(e.target.files[0]),
        });
        formData.set(name, e.target.files[0]);
        setError("");
      } else {
        formData.delete(name);
        e.target.value = null;
        setError("Thumbnail should be of jpg, jpeg, png only");
      }
    } else if (name == "banner") {
      if (
        e.target.files[0]?.type === "image/jpeg" ||
        e.target.files[0]?.type === "image/png" ||
        e.target.files[0]?.type === "image/jpg"
      ) {
        setLession({
          ...lession,
          banner: URL.createObjectURL(e.target.files[0]),
        });
        formData.set(name, e.target.files[0]);
        setError("");
      } else {
        formData.delete(name);
        e.target.value = null;
        setError("Banner should be of jpg, jpeg, png only");
      }
    } else {
      setLession({ ...lession, [name]: value });
      formData.set(name, value);
    }
  };

  const callAxiosRequest = async (toUpdate = "") => {
    return await axios.patch(
      `${API}/api/adlesson/${adlessionId}${toUpdate}`,
      formData,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/formdata",
        },
      }
    );
  };

  const onSubmit = async (e, section) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    console.log("here sending data", formData);
    if (section === "title") {
      if (formData.get("title").trim() === "") {
        setLoading(false);
        return setError("All fields are must!");
      }
      await callAxiosRequest("/details")
        .then(() => {
          setLoading(false);
          setSuccess(!success);
          setError("");
          swal({
            title: "Changes are saved Successfully!",

            icon: "success",
            buttons: {
              SaveAndExit: {
                text: "Save and Exit",
                value: "SaveAndExit",
              },
              OkCancel: {
                text: "Save And Continue",
                value: "SaveAndContinue",
              },
            },
          }).then((value) => {
            switch (value) {
              case "SaveAndExit":
                history.push("/ad_video");
                break;
              case "SaveAndContinue":
                tab2.current.click();
                break;
              default:
            }
          });
        })
        .catch((err) => {
          setLoading(false);
          setSuccess((prev) => !prev);
          swal({
            title: "Error",
            text: err.message,
            icon: "error",
            buttons: true,
            dangerMode: true,
          });
          console.log(err);
        });
    }
    if (section === "images") {
      await callAxiosRequest("/thumbnail")
        .then(() => {
          setLoading(false);
          setSuccess(!success);
          setError("");
          swal({
            title: "Changes are saved Successfully!",

            icon: "success",
            buttons: {
              SaveAndExit: {
                text: "Save and Exit",
                value: "SaveAndExit",
              },
              OkCancel: {
                text: "Save And Continue",
                value: "SaveAndContinue",
              },
            },
          }).then((value) => {
            switch (value) {
              case "SaveAndExit":
                history.push("/ad_video");
                break;
              case "SaveAndContinue":
                tab3.current.click();
                break;
              default:
            }
          });
        })
        .catch((err) => {
          setLoading(false);
          setSuccess((prev) => !prev);
          swal({
            title: "Error",
            text: err.message,
            icon: "error",
            buttons: true,
            dangerMode: true,
          });
          console.log(err);
        });
      return;
    }
    if (section === "video") {
      await callAxiosRequest("/video")
        .then(() => {
          setLoading(false);
          setSuccess(!success);
          setError("");
          swal({
            title: "Video updated Successfully!",
            icon: "success",
            button: "Return",
            successMode: true,
          }).then((value) => {
            history.push("/ad_video");
          });
        })
        .catch((err) => {
          setLoading(false);
          setSuccess((prev) => !prev);
          swal({
            title: "Error",
            text: err.message,
            icon: "error",
            buttons: true,
            dangerMode: true,
          });
          console.log(err);
        });
    }
  };

  const handleEdit = (e, type) => {
    const length = e.target.value.length;
    switch (type) {
      case "title":
        if (wordLimit.title - length !== -1) {
          handleChange(e);
          setTitleLen(wordLimit.title - length);
        }
        break;
      case "description":
        if (wordLimit.description - length !== -1) {
          handleChange(e);
          setDescriptionLen(wordLimit.description - length);
        }
        break;
      default:
        console.log("Incorrect Type");
    }
  };

  const handleChangeTab = () => {
    formData.delete("thumbnail");
    formData.delete("banner");
    formData.delete("video");
    setError("");
  };



  if (dataLoad) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center p-4  rounded shadow">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          {/* <div className="mt-3 fs-5 text-primary">Edit Loading...</div> */}
        </div>
      </div>
    ); // Display loading spinner
  }

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Advertisements</h4>
                {/* {console.log(subjects)} */}
                {/* {console.log(languages)} */}
                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Advertisements
                    </li>
                    <li className='breadcrumb-item'>Edit Video</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-md-12 col-lg-9 col-xl-8'>
                      <h1 className='text-left head-small'>Edit Video </h1>

                      <ul className='nav nav-tabs' role='tablist'>
                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className='nav-link active'
                            data-toggle='tab'
                            href='#title'
                            role='tab'
                            ref={tab1}
                            onClick={handleChangeTab}>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/title-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Title</span>
                          </a>
                        </li>
                        {/* <li className="nav-item waves-effect waves-light">
                          <a className="nav-link"

                            data-toggle="tab"
                            href="#meta-data"
                            role="tab">
                            <span className="d-block d-sm-none">
                              <img alt="" src="assets/images/icons/info-icon.png" />
                            </span>
                            <span className="d-none d-sm-block">Meta Data</span>
                          </a>
                        </li> */}

                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className={`nav-link `}
                            data-toggle='tab'
                            href='#images'
                            role='tab'
                            ref={tab2}
                            onClick={handleChangeTab}>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/img-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Images</span>
                          </a>
                        </li>

                        <li className='nav-item waves-effect waves-light'>
                          <a
                            className={`nav-link `}
                            data-toggle='tab'
                            href='#video'
                            role='tab'
                            ref={tab3}
                            onClick={handleChangeTab}>
                            <span className='d-block d-sm-none'>
                              <img
                                alt=''
                                src='assets/images/icons/video-icon.png'
                              />
                            </span>
                            <span className='d-none d-sm-block'>Video</span>
                          </a>
                        </li>
                        {/* <li className="nav-item waves-effect waves-light">
                          <a
                            className={`nav-link ${lession.thumbnail.length != 0 &&
                              lession.video.length != 0
                              ? ""
                              : "disabled"
                              }`}
                            data-toggle="tab"
                            href="#launch"
                            role="tab"
                          >
                            <span className="d-block d-sm-none">
                              {console.log(lession)}
                              <img alt="" src="assets/images/icons/date-icon.png" />
                            </span>
                            <span className="d-none d-sm-block">Launch Date</span>
                          </a>
                        </li> */}
                      </ul>

                      <div className='tab-content video-tab p-3 text-muted'>
                        <div
                          className='tab-pane active'
                          id='title'
                          role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Title
                              </label>
                              <div className='col-md-8'>
                                <input
                                  onChange={(e) => handleEdit(e, "title")}
                                  type='text'
                                  className='form-control input-field'
                                  name='title'
                                  value={lession.title}
                                />
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining : {titleLen}
                                </p>
                              </div>
                            </div>

                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Description(optional)
                              </label>
                              <div className='col-md-8'>
                                <textarea
                                  onChange={(e) => handleEdit(e, "description")}
                                  value={lession.description}
                                  name='description'
                                  className='form-control input-field'
                                  rows='5'></textarea>
                                <p className='pt-1 pl-2 text-secondary'>
                                  Characters Remaining : {descriptionLen}
                                </p>
                              </div>
                            </div>
                            <div className='w-100 text-center'>
                              <button
                                onClick={(e) => onSubmit(e, "title")}
                                style={{ width: "120px" }}
                                type='button mx-auto'
                                className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                <ClipLoader loading={loading} size={18} />
                                {!loading && "Save"}
                              </button>
                            </div>
                            {/* <div className="form-group width-100 mb-30 row">
                              <label className="col-md-4 control-label">
                                Select Language
                              </label>
                              <div className="col-md-8">
                                <select
                                  className="form-control input-field"
                                  // defaultValue=""
                                  name="languageid"
                                  onChange={handleChange}
                                  value={lession.languageid}
                                >
                                  <option value="">Select Language</option>
                                  {languages.length != 0 &&
                                    languages.map((lang, index) => {
                                      return (
                                        <option value={lang._id} key={lang._id}>
                                          {lang.name}
                                        </option>
                                      );
                                    })}
                                </select>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        {/*/////////////////////////////// meta dat start here //////////////////// */}
                        {/* <div
                          className="tab-pane"
                          id="meta-data"
                          role="tabpanel"
                        >
                          <div className="panel-body p-20">
                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Search Title
                              </label>
                              <div className="col-md-8">
                                <input
                                  type="text"
                                  className="form-control input-field"
                                  value={searchMovie}
                                  onChange={(e) => {
                                    handleSearchMovie(e.target.value);
                                    setSearchMovie(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            {movieList.map((movie) => (
                              <Link
                                style={{ height: "7vh", display: "block" }}
                                onClick={() => fillMetadata(movie.id)}
                              >
                                <img
                                  alt=""
                                  src={movie.image}
                                  style={{
                                    height: "90%",
                                    width: "6vw",
                                    marginRight: "8vw",
                                  }}
                                />
                                <span>{movie.title}</span>
                                <span>{movie.description}</span>
                              </Link>
                            ))}

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Title
                              </label>
                              <div className="col-md-8">
                                {fill ? metaDataTitle : lession.title}
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Plot
                              </label>
                              <div className="col-md-8">
                                {fill ? metaDataPlot : lession.Plot}
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Director
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      <tr> */}
                        {/* <td><img alt="" src="assets/images/avatar-2.jpg" className="img-circle" height="50"/></td> */}
                        {/* <td>
                                          {fill
                                            ? metaDataDirector
                                            : lession.directors}
                                        </td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Writer
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      <tr> */}
                        {/* <td><img alt="" src="assets/images/avatar-2.jpg" className="img-circle" height="50"/></td> */}
                        {/* <td>
                                          {fill
                                            ? metaDataWriter
                                            : lession.Writers}
                                        </td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Crew
                              </label>
                              <div className="col-md-8">
                                <div className="table-responsive table-shoot">
                                  <table className="table">
                                    <tbody>
                                      {fill
                                        ? metaDataCrew &&
                                        metaDataCrew.map((actor) => (
                                          <tr>
                                            <td>
                                              <img
                                                alt=""
                                                src={actor.image}
                                                className="img-circle"
                                                height="50"
                                              />
                                            </td>
                                            <td>{actor.name}</td>
                                            <td>Actor</td>
                                          </tr>
                                        ))
                                        : lession.Actors_list &&
                                        lession.Actors_list.map((actor) => (
                                          <tr key={actor.id}>
                                            <td>
                                              <img
                                                alt=""
                                                src={actor.image}
                                                className="img-circle"
                                                height="50"
                                              />
                                            </td>
                                            <td>{actor.name}</td>
                                            <td>Actor</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="form-group width-100 mb-30 row">
                              <label className="col-md-4 control-label"></label>
                              <div className="col-md-8"> */}
                        {/* <Link><button type="button"
className="btn btn-success btn-login waves-effect waves-light mr-3">Save</button>
</Link> */}
                        {/* </div>
                            </div>
                          </div>
                        </div> */}
                        {/*/////////////////////////////// meta dat end here //////////////////// */}

                        <div className='tab-pane' id='images' role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Upload Thumbnail Image
                                <br />
                                <span className='size'>(320 x 180 px)</span>
                              </label>
                              <div className='col-md-8'>
                                <input
                                  onChange={handleChange}
                                  name='thumbnail'
                                  type='file'
                                  accept='image/png, image/jpg, image/jpeg'
                                  className='form-control input-field'
                                />
                                <div>
                                  <img
                                    className='img-fluid mt-2'
                                    style={{
                                      height: "125px",
                                      width: "235px",
                                    }}
                                    alt='200x200'
                                    src={lession.thumbnail}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Upload Banner Image
                                <br />
                                <span className='size'>(320 x 180 px)</span>
                              </label>
                              <div className='col-md-8'>
                                <input
                                  onChange={handleChange}
                                  name='banner'
                                  type='file'
                                  className='form-control input-field'
                                  accept='image/png, image/jpg, image/jpeg'
                                />
                                <div>
                                  <img
                                    className='img-fluid mt-2'
                                    style={{
                                      height: "125px",
                                      width: "235px",
                                    }}
                                    alt='200x200'
                                    src={lession.banner}
                                  />
                                </div>
                              </div>
                            </div> */}
                            <div className='w-100 text-center'>
                              <button
                                onClick={(e) => onSubmit(e, "images")}
                                style={{ width: "120px" }}
                                type='button mx-auto'
                                className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                <ClipLoader loading={loading} size={18} />
                                {!loading && "Save"}
                              </button>
                            </div>

                            {/* <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label">
                                Upload Banner Image
                                <br />
                                <span className="size">(1125 x 451 px)</span>
                              </label>
                              <div className="col-md-8">
                                <input
                                  type="file"
                                  name="banner"
                                  onChange={handleChange}
                                  className="form-control input-field"
                                />
                                <div>
                                  <img
                                    className="img-fluid mt-2"
                                    style={{
                                      width: "235px",
                                      height: "125px",
                                    }}
                                    alt="200x200"
                                    src={lession.banner}
                                  />
                                </div>
                              </div>
                            </div> */}

                            {/* <div className="form-group mb-30 width-100 row">
                              <label className="col-md-4 control-label"></label>
                              <div className="col-md-8">
                                <button
                                  disabled={validForm}
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                >
                                  Save
                                </button>
                              </div>
                            </div> */}
                          </div>
                        </div>

                        <div className='tab-pane' id='launch' role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Date
                              </label>
                              <div className='col-md-8'>
                                <div className='form-group width-100'>
                                  <div className='input-group'>
                                    {/* <DatePicker
                                      selected={lession.launchDate}
                                      name="launchDate"
                                      onChange={(date) => {
                                        setLession({
                                          ...lession,
                                          launchDate: date,
                                        });
                                        formData.set(
                                          "launchDate",
                                          date.toISOString()
                                        );
                                      }}
                                    /> */}

                                    <div className='input-group-append'>
                                      <span className='input-group-text'>
                                        <i
                                          className='fa fa-calendar'
                                          aria-hidden='true'></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='form-group m-b-0 row'>
                              <div className='col-md-4'></div>
                            </div>
                          </div>
                        </div>

                        <div className='tab-pane' id='video' role='tabpanel'>
                          <div className='panel-body p-20'>
                            <div className='form-group mb-30 width-100 row'>
                              <label className='col-md-4 control-label'>
                                Upload Video
                                <br />
                                <span className='size'>
                                  (mp4 file format only)
                                </span>
                              </label>
                              <div className='col-md-8'>
                                <input
                                  type="file"
                                  onChange={handleChange}
                                  name="video"
                                  className="form-control input-field mb-1"
                                  accept="video/*"
                                />
                                <Player key={lession.video}>
                                  {/* <source src={lession.video} /> */}
                                  <source
                                    src={lession.video}
                                    type='video/mp4'
                                  />
                                </Player>
                                <small>File size must be less than 100mb
                                </small>
                              </div>
                            </div>

                            <div className='w-100 text-center'>
                              <button
                                onClick={(e) => onSubmit(e, "video")}
                                style={{ width: "120px" }}
                                type='button mx-auto'
                                className='btn btn-success btn-login waves-effect waves-light mr-3'>
                                <ClipLoader loading={loading} size={18} />
                                {!loading && "Save"}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className='text-center'>
                          <span className='text-danger'>{error}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
